import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { utlogMap, functionId } from "@/api/index";
import { getUrl, getCookie } from '../utils/browser';
Vue.use(VueRouter)
console.log(Vue.reporter);
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        redirect: '/explor',
    },
    {
        path: '/explor',
        name: 'Explor',
        component: () => import(/* webpackChunkName: "explor" */ '../views/data/Explor.vue'),
    },
    {
        path: '/tibet-plateau',
        name: 'TibetPlateau',
        component: () => import(/* webpackChunkName: "tibetplateau" */ '../views/data/TibetPlateau.vue'),
    },
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),

    // },
    {
        path: '/glossary',
        name: 'Gloss',
        component: () => import(/* webpackChunkName: "glass" */ '../views/data/Gloss.vue')
    },
    {
        path: '/download',
        name: 'Download',
        component: () => import(/* webpackChunkName: "download" */ '../views/data/Download.vue'),
    },
    {
        path: '/download-list',
        name: 'DownloadList',
        component: () => import(/* webpackChunkName: "download-list" */ '../views/data/DownloadList.vue')
    },
    {
        path: "/literature/index",
        name: 'literature-list',
        component: () => import(/* webpackChunkName: "literature-list" */ '../views/LiteratureList.vue')
    },
    {
        path: "/literature_details/:r_id",
        name: 'literature',
        component: () => import(/* webpackChunkName: "literature" */ '../views/LiteratureDetails.vue')
    },
    {
        path: "/top-search-list",
        name: 'TopSearchList',
        component: () => import(/* webpackChunkName: "taxon-list" */ '../views/TopSearchList.vue')
    },
    {
        path: "/fossil_details/:fossil_id",
        name: 'fossilDetails',
        component: () => import(/* webpackChunkName: "fossil" */ '../views/SpecimensDetails.vue')
    },
    {
        path: "/glossary_details/:glossary_id",
        name: 'glossaryDetails',
        component: () => import(/* webpackChunkName: "glossary" */ '../views/GlossDetails.vue')
    }, {
        path: '/service-info',
        name: 'ServiceInfo',
        component: () => import(/* webpackChunkName: "service-info" */ '../views/Statistics.vue')
    },
    // {
    //     path:'/biodiversity',
    //     name:'biodiversity',
    //     component:() =>import(/* webpackChunkName: "biodiversity" */ '../views/Biodiversity.vue')
    // },
    {
        path: '/notfound',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFound.vue')
    },
    {
        path: '*',
        name: 'All',
        redirect: '/notfound'
    }

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})
const whiteList = new Set([
    'Download',
    "Explor",
    "Gloss"
])
router.beforeEach((to, from, next) => {
    let preUrl = from.fullPath == '/' ? '直接访问' : (getUrl() + from.fullPath);
    if (to.fullPath == from.fullPath) return
    sessionStorage.setItem('preUrl', preUrl);
    let uuid = localStorage.getItem("uuid");
    if (!uuid) {
        let idstr = window.navigator.userAgent.replace(/[^\w]/gi, '')
        localStorage.setItem("uuid", idstr);
        uuid = idstr;
    }
    let logMap = {
        eventType: 'pageOpen',
        url: getUrl() + to.fullPath,
        preUrl: preUrl,
        functionId: to?.params?.functionId,
        cookieId: getCookie('sessionId'),//使用的插件生成的cookie
        uuid: uuid
    }
    if (whiteList.has(to.name)) {
        logMap.utlogMap = { itemName: `header_manu.${to.name.toLocaleLowerCase()}` };
    }


    utlogMap(logMap).then(res => {
        // console.log(res)
    })
    next()

})
export default router
